import { css } from '@emotion/core'
import { colors } from 'styles/variables'

export const icon = css`
  color: ${colors.white100};
`
